import React, { useState } from "react";
import { toast } from "react-toastify";

const AbsentPopup = ({ markFullDayAbsent, tchId, onClose }) => {


    const lstHour = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    const lstMinutes = ["00", "05", "10", "15", "20", "25", "30", "35", "40", "45", "50", "55"];
    const lstAMPM = ["AM", 'PM'];
    const [startHour, setStartHour] = useState("");
    const [startMinute, setStartMinute] = useState("");
    const [startAMPM, setStartAMPM] = useState("AM");
    const [endHour, setEndHour] = useState("");
    const [endMinute, setEndMinute] = useState("");
    const [endAMPM, setEndAMPM] = useState("AM");
    const [flgFullDayAbsent, setFlgFullDayAbsent] = useState(true);


    const handleAbsentSave = () => {
        const absentFromTm = (startHour && startMinute ? startHour + ":" : "") + (startHour && startMinute ? startMinute + " " : "") + (startHour && startMinute ? startAMPM : "");
        const absentToTm = (endHour && endMinute ? endHour + ":" : "") + (endHour && endMinute ? endMinute + " " : "") + (endHour && endMinute ? endAMPM : "");
        if (flgFullDayAbsent) {
            markFullDayAbsent("", "");  // Call the function to mark full day absent
        } else {
            if (absentFromTm === "") {
                toast.warn("Please enter from time");
                return;
            }
            if (absentToTm === "") {
                toast.warn("Please enter to time");
                return;
            }
            markFullDayAbsent(absentFromTm, absentToTm);  // Call the function to mark special time absent
        }
    };


    return (
        <div className="periodFormPopup">
            <div className="col-sm-12 padding-remove" style={{ height: "50px" }}>
                <div className="col-sm-8" style={{ fontSize: "large" }}>
                    Mark Absent
                </div>
                <div className="col-sm-4 padding-remove">
                    <button
                        type="button"
                        title="Close Popup"
                        onClick={onClose}
                        className="btn btn-info text-center pull-right"
                    >
                        X
                    </button>
                </div>
            </div>
            <div className="col-sm-10 col-xs-12 col-centered padding-remove" style={{ height: "50px" }}>
                <div className="form-group col-md-12" style={{ padding: "5px 0" }}>
                    <div className="form-group col-md-12 padding-remove">
                        {/* radio buttons for full day , special time absent */}
                        <div className="col-md-6 col-xs-12">
                            <label>
                                <input
                                    type="radio"
                                    checked={flgFullDayAbsent}
                                    // add some style to label so that it is aligned with radio button
                                    style={{ margin: "7px" }}
                                    onChange={() => setFlgFullDayAbsent(true)}
                                />
                                Full Day
                            </label>
                        </div>
                        <div className="col-md-6 col-xs-12">
                            <label>
                                <input
                                    type="radio"
                                    style={{ margin: "7px" }}
                                    checked={!flgFullDayAbsent}
                                    onChange={() => setFlgFullDayAbsent(false)}
                                />
                                Special Time
                            </label>
                        </div>
                    </div>
                    <div className="form-group col-md-12 padding-remove">
                        <label className="control-label col-md-4 col-xs-6" style={{ padding: "7px 0 0 0" }}>
                            Start Time:
                        </label>
                        <div className="col-sm-8 padding-remove">
                            <div className='col-sm-4 padding-remove'>
                                <select
                                    autoComplete='off'
                                    name='Start Hour'
                                    className='form-control '
                                    style={{ height: 30 }}
                                    value={startHour}
                                    onChange={(e) => setStartHour(e.target.value)}
                                     disabled={flgFullDayAbsent}
                                >
                                    <option value=''>Hour</option>
                                    {
                                        lstHour.map((startHour) => (
                                            <option value={startHour} key={startHour} id={startHour}>
                                                {startHour}
                                            </option>
                                        ))
                                    }
                                </select>
                            </div>
                            <div className='col-sm-5 padding-remove '>
                                <select
                                    autoComplete='off'
                                    name='Start Minute'
                                    className='form-control '
                                    style={{ height: 30 }}
                                    value={startMinute}
                                    onChange={(e) => setStartMinute(e.target.value)}
                                     disabled={flgFullDayAbsent}
                                >
                                    <option value=''>Minutes</option>
                                    {
                                        lstMinutes.map((startMinute) => (
                                            <option value={startMinute} key={startMinute} id={startMinute}>
                                                {startMinute}
                                            </option>
                                        ))
                                    }
                                </select>
                            </div>
                            <div className='col-sm-3 padding-remove'>
                                <select
                                    autoComplete='off'
                                    name='Start AMPM'
                                    className='form-control '
                                    style={{ height: 30 }}
                                    value={startAMPM}
                                    onChange={(e) => setStartAMPM(e.target.value)}
                                     disabled={flgFullDayAbsent}
                                >
                                    {
                                        lstAMPM.map((startAMPM) => (
                                            <option value={startAMPM} key={startAMPM} id={startAMPM}>
                                                {startAMPM}
                                            </option>
                                        ))
                                    }
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="form-group col-md-12 padding-remove">
                        <label className="control-label col-md-4" style={{ padding: "7px 0 0 0" }}>
                            End Time:
                        </label>
                        <div className="col-sm-8 padding-remove">
                            <div className='col-sm-4 padding-remove'>
                                <select
                                    autoComplete='off'
                                    name='End Hour'
                                    className='form-control '
                                    style={{ height: 30 }}
                                    value={endHour}
                                    onChange={(e) => setEndHour(e.target.value)}
                                     disabled={flgFullDayAbsent}
                                >
                                    <option value=''>Hour</option>
                                    {
                                        lstHour.map((endHour) => (
                                            <option value={endHour} key={endHour} id={endHour}>
                                                {endHour}
                                            </option>
                                        ))
                                    }
                                </select>
                            </div>
                            <div className='col-sm-5 padding-remove '>
                                <select
                                    autoComplete='off'
                                    name='End Minute'
                                    className='form-control '
                                    style={{ height: 30 }}
                                    value={endMinute}
                                    onChange={(e) => setEndMinute(e.target.value)}
                                    disabled={flgFullDayAbsent}
                                >
                                    <option value=''>Minutes</option>
                                    {
                                        lstMinutes.map((endMinute) => (
                                            <option value={endMinute} key={endMinute} id={endMinute}>
                                                {endMinute}
                                            </option>
                                        ))
                                    }
                                </select>
                            </div>
                            <div className='col-sm-3 padding-remove'>
                                <select
                                    autoComplete='off'
                                    name='End AMPM'
                                    className='form-control '
                                    style={{ height: 30 }}
                                    value={endAMPM}
                                    onChange={(e) => setEndAMPM(e.target.value)}
                                     disabled={flgFullDayAbsent}
                                >
                                    {
                                        lstAMPM.map((endAMPM) => (
                                            <option value={endAMPM} key={endAMPM} id={endAMPM}>
                                                {endAMPM}
                                            </option>
                                        ))
                                    }
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-10 padding-remove" style={{ height: "50px", marginTop: "15px" }}>
                        <div className="col-sm-6 col-md-6 padding-remove ">
                            <div className="col-sm-4 col-md-4 col-centered padding-remove ">
                                <button type="button" className="btn btn-info" onClick={onClose}>
                                    Cancel
                                </button>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-6 padding-remove ">
                            <div className="col-sm-4 col-md-4 col-centered padding-remove ">
                                <button type="button" className="btn btn-info" onClick={handleAbsentSave}>
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AbsentPopup;